import { AffiliatedCompany } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request/request'

export const deleteAffiliatedCompany = (id: number) => Request.delete(Request.urls.bank.affiliatedCompany, { id })

export const saveAffiliatedCompany = (relation: AffiliatedCompany) => {
  const func = relation.id ? Request.put : Request.post
  return func(Request.urls.bank.affiliatedCompany, relation)
}
